// play() rejects with AbortError when the element is removed, paused, or
// reloaded before the request settles, and with NotAllowedError when the
// browser blocks autoplay. Both are expected for historias previews.
export function safePlay(video) {
    if (!video || typeof video.play !== 'function') {
        return
    }

    try {
        const pending = video.play()
        if (pending && typeof pending.catch === 'function') {
            pending.catch(() => {})
        }
    } catch (error) {
        // Some browsers throw synchronously instead of rejecting.
    }
}
